import TemplateView from '../../../TemplateView'

export default class CollapseAllButton extends TemplateView {
    constructor({
        onCollapseAllCallback = (isAllCollapsed) => {},
    }) {
        super()

        this.onCollapseAllCallback = onCollapseAllCallback

        this.state = {
            isAllCollapsed: false,
            disableCollapse: false,
        }

        this.onStatePropertyChanged('isAllCollapsed', this._handleAllCollapsed)

        this.onStatePropertyChanged('disableCollapse', (disableCollapse) => {
            this.getEl().toggleClass('disableCollapse', disableCollapse)
        })
    }

    templateHtml() {
        return "<div class='collapseAllButtons'>" +
               "    <div class='collapseAllButton'>" +
               "        <div class='collapseAllButtonImage'></div>" +
               "        <div class='collapseAllButtonLabel'><%=collapseAllText%></div>" +
               "    </div>" +
               "    <div class='expandAllButton'>" +
               "        <div class='expandAllButtonImage'></div>" +
               "        <div class='expandAllButtonLabel'><%=expandAllText%></div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            collapseAllText: 'task.list.kanban.filters_panel.collapse_all',
            expandAllText: 'task.list.kanban.filters_panel.expand_all',
        }
    }

    afterRender() {
        this.$collapseAllButton = this.find(".collapseAllButton").click(() => {
            if (!this.state.disableCollapse) {
                this.onCollapseAllCallback(true)
            }
        })
        this.$expandAllButton = this.find(".expandAllButton").click(() =>{
            if (!this.state.disableCollapse) {
                this.onCollapseAllCallback(false)
            }
        })
        this.renderInitialState()
    }

    _handleAllCollapsed = (isAllCollapsed) => {
        this.$collapseAllButton.toggle(!isAllCollapsed)
        this.$expandAllButton.toggle(isAllCollapsed)
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/CollapseAllButton.js